"use strict";

exports.__esModule = true;
exports["default"] = getPercentageOfPixel;
function getPercentageOfPixel(setDisclaimerFontSizePrcnt, _ref) {
  var _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === void 0 ? '10px' : _ref$fontSize;
  var fontSizeInt = parseInt(fontSize, 10) || 16;
  var sizeAmount = setDisclaimerFontSizePrcnt ? Number(setDisclaimerFontSizePrcnt) : fontSizeInt < 40 ? 70 : 50;
  var calculatedFontSize = fontSizeInt * sizeAmount / 100;
  calculatedFontSize = calculatedFontSize + "px";
  return calculatedFontSize;
}